import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Chart from './components/Chart';
import { FullScreenChartModal } from 'components';

import useModal from 'hooks/common/useModal';

import { IProfitChartProps } from './ProfitChart.types';

const ProfitChart = ({ aid, uid, requestCallback, ...props }: IProfitChartProps) => {
  const { t } = useTranslation();

  const { open, onOpen, onClose } = useModal();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getChartData = async () => {
      setLoading(true);

      const result = await requestCallback();

      const { data, success } = result || {};

      if (data === undefined) {
        return;
      }

      if (success) {
        setData(data);
      } else {
        setData(null);
      }

      setLoading(false);
    };

    getChartData();
  }, [aid, uid, requestCallback]);

  return (
    <>
      <Chart
        enableExpend
        data={data}
        loading={loading}
        title={t('page.dashboard.blocks.incomeChart.title')}
        onExpand={onOpen}
        {...props}
      />

      <FullScreenChartModal title={t('page.dashboard.blocks.incomeChart.title')} open={open} onClose={onClose}>
        <Chart data={data} loading={loading} height="100%" width="100%" {...props} />
      </FullScreenChartModal>
    </>
  );
};

export default ProfitChart;
